export default {
    ToggleDisplayLayer: 'toggle-display-layout',
    SelectDisplayBasemap: 'select-base-map',
    HightLightPolygon: 'hight-light-polygon',
    Delete_All_HightLightedPolygon:'delete-hight-lighted-polygon',
    Add_Single_HightLightedPolygon: 'add-single-hight-lighted-polygon',
    Delete_Single_HightLightedPolygon: 'delete-single-hight-lighted-polygon',
    CenterMapAndZoom: 'center-map-and-zoom',
    AddLayerManually: 'add-layer-manually'
}